// src/components/GlucoseChart.js
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import {
  LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
  ReferenceLine
} from "recharts";

export default function GlucoseChart() {
  const [readings, setReadings] = useState([]);
  const [range, setRange] = useState("30"); // default = last 30 days

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const q = query(
      collection(db, "users", user.uid, "glucoseReadings"),
      orderBy("dateTime", "asc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        const item = doc.data();
        return {
          ...item,
          dateTime: item.dateTime?.toDate(),
        };
      });
      setReadings(data);
    });

    return () => unsubscribe();
  }, []);

  // Filter data by range
  const filteredData = readings.filter((r) => {
    if (!r.dateTime) return false;
    const days = parseInt(range);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - days);
    return r.dateTime >= cutoff;
  }).map((r) => ({
    ...r,
    dateTime: r.dateTime.toLocaleDateString(),
  }));

  // CSV Export
  const exportCSV = () => {
    const headers = ["Date", "Glucose (mg/dL)", "Condition"];
    const rows = filteredData.map(r => [
      r.dateTime,
      r.glucose,
      r.condition
    ]);
    let csvContent = "data:text/csv;charset=utf-8," 
      + [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "glucose_readings.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ width: "100%", height: 350, marginTop: "1rem" }}>
      <div style={{ marginBottom: "0.5rem" }}>
        <label>Range: </label>
        <select value={range} onChange={(e) => setRange(e.target.value)}>
          <option value="7">Last 7 days</option>
          <option value="30">Last 30 days</option>
          <option value="90">Last 90 days</option>
          <option value="365">Last 1 year</option>
          <option value="9999">All</option>
        </select>
        <button onClick={exportCSV} style={{ marginLeft: "1rem" }}>
          Export to CSV
        </button>
      </div>

      <ResponsiveContainer>
        <LineChart data={filteredData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="dateTime" />
          <YAxis domain={[0, "auto"]} />
          <Tooltip />
          <Legend />
          <ReferenceLine y={70} stroke="blue" strokeDasharray="3 3" />
          <ReferenceLine y={140} stroke="red" strokeDasharray="3 3" />
          <Line type="monotone" dataKey="glucose" stroke="green" dot />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
